import {gql} from '@apollo/client'

export const GET_HISTORY = gql`
  query GetHistory($itemType: String!, $itemId: ID!) {
    history(itemType: $itemType, itemId: $itemId) {
      id
      timestamp
      user
      event
      details
      notes
    }
  }
`

export const UPDATE_HISTORY = gql`
  mutation UpdateHistory($itemType: String!, $itemId: ID!, $notes: String!) {
    history(itemType: $itemType, itemId: $itemId, notes: $notes) {
      id
      timestamp
      user
      event
      details
      notes
    }
  }
`
